import { render, staticRenderFns } from "./DevBar.vue?vue&type=template&id=72956cd3"
import script from "./DevBar.vue?vue&type=script&lang=ts"
export * from "./DevBar.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports